import { __extends } from "tslib";
import { RenderUtils } from '@wix/photography-client-lib';
var Utils = /** @class */ (function (_super) {
    __extends(Utils, _super);
    /* @ngInject */
    function Utils() {
        return _super.call(this) || this;
    }
    Utils.prototype.pick = function (obj, keys) {
        var res = {};
        Object.entries(obj || {}).forEach(function (_a) {
            var key = _a[0], val = _a[1];
            if (keys.indexOf(key) >= 0) {
                res[key] = val;
            }
        });
        return res;
    };
    Utils.prototype.debounce = function (callback, wait) {
        var _this = this;
        var timeout;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                callback.apply(_this, args);
            }, wait);
        };
    };
    Utils.prototype.get = function (obj, path, defaultValue) {
        var result = String.prototype.split
            .call(path, /[,[\].]+?/)
            .filter(Boolean)
            .reduce(function (res, key) { return (res !== null && res !== undefined ? res[key] : res); }, obj);
        return result === undefined || result === obj ? defaultValue : result;
    };
    Utils.prototype.flipGalleryHorizontalAlign = function (galleryHorizontalAlign) {
        // Usage in RTL galleries
        return galleryHorizontalAlign === 'flex-start'
            ? 'flex-end'
            : galleryHorizontalAlign === 'flex-end'
                ? 'flex-start'
                : galleryHorizontalAlign;
    };
    return Utils;
}(RenderUtils));
export var utils = new Utils();
//# sourceMappingURL=utils.js.map